import PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';
import { useProjeDetay } from '../../hooks/useProjeDetay';
import YerbisConstants from '../../constants/yerbisConstants';
import {
  KAMU_MUHENDISI,
  UYGULAMA_YONETICISI,
  JEOFIZIK_MUHENDISI,
  JEOLOJI_MUHENDISI,
  JEOLOJI_VE_JEOFIZIK_MUHENDISI,
  FIRMA,
  IL_SUBE_MUDURU,
  SUBE_MUDURU,
} from '../../constants/roleConstant';

function Can({ perform, notPerform, children }) {
  const { hasRoles } = useAuth();

  const hasPerformRoles = hasRoles(perform);
  const hasNotPerformRoles = notPerform ? hasRoles(notPerform) : false;

  if (!hasPerformRoles) {
    return null;
  }

  if (hasNotPerformRoles) {
    return null;
  }

  return children;
}

function HaritalarCalismasiIseGosterme({ calismaTurId, children }) {
  const haritaCalismasi = Object.values(YerbisConstants.HaritaTurleri).includes(Number(calismaTurId));

  if (haritaCalismasi) {
    return null;
  }

  return children;
}

function RolCalismaYetki({ calismaTurId, children }) {
  const { hasRoles, hasRole } = useAuth();
  if (hasRoles([UYGULAMA_YONETICISI, KAMU_MUHENDISI])) {
    return children;
  }

  const jeofizikCalismasi = Object.values(YerbisConstants.JeofizikCalismaTurleri).includes(Number(calismaTurId));
  const jeolojiCalismasi = !jeofizikCalismasi;

  if (jeofizikCalismasi && !hasRole(JEOFIZIK_MUHENDISI) && !hasRole(JEOLOJI_VE_JEOFIZIK_MUHENDISI)) {
    return null;
  }

  if (jeolojiCalismasi && !hasRole(JEOLOJI_MUHENDISI) && !hasRole(JEOLOJI_VE_JEOFIZIK_MUHENDISI)) {
    return null;
  }
  return children;
}

function TypeCan({ types, children }) {
  const { hasTypes } = useAuth();

  if (!hasTypes(types)) {
    return null;
  }

  return children;
}

function ProjePaftalariniYenidenOlusturButonuGoster({ children }) {
  const { getProjeDurumId, getProjeKilit } = useProjeDetay();
  const { hasRoles, hasRole } = useAuth();

  const kilitMi = getProjeKilit();
  if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
    return null;
  }

  const durumId = getProjeDurumId();
  if (
    durumId !== YerbisConstants.ProjeDurumKodlari.Taslak &&
    durumId !== YerbisConstants.ProjeDurumKodlari.Hazirlik &&
    durumId !== YerbisConstants.ProjeDurumKodlari.Basvuru &&
    durumId !== YerbisConstants.ProjeDurumKodlari.OnEtut &&
    durumId !== YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari
  ) {
    return null;
  }

  if (hasRole(UYGULAMA_YONETICISI) || durumId == YerbisConstants.ProjeDurumKodlari.Taslak) {
    return children;
  }

  if (durumId == YerbisConstants.ProjeDurumKodlari.Hazirlik && hasRole(FIRMA)) {
    // return children;
  }

  if (
    (durumId == YerbisConstants.ProjeDurumKodlari.Basvuru ||
      durumId == YerbisConstants.ProjeDurumKodlari.OnEtut ||
      durumId == YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari) &&
    hasRoles([IL_SUBE_MUDURU, SUBE_MUDURU])
  ) {
    return children;
  }

  return null;
}

function ProjeAlaniGuncelleButonuGoster({ children }) {
  const { getProjeDurumId, getProjeKilit } = useProjeDetay();
  const { hasRoles, hasRole } = useAuth();

  const kilitMi = getProjeKilit();
  if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
    return null;
  }

  const durumId = getProjeDurumId();
  if (
    durumId !== YerbisConstants.ProjeDurumKodlari.Taslak &&
    durumId !== YerbisConstants.ProjeDurumKodlari.Hazirlik &&
    durumId !== YerbisConstants.ProjeDurumKodlari.Basvuru &&
    durumId !== YerbisConstants.ProjeDurumKodlari.OnEtut &&
    durumId !== YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari
  ) {
    return null;
  }

  if (hasRole(UYGULAMA_YONETICISI)) {
    return children;
  }

  if (durumId == YerbisConstants.ProjeDurumKodlari.Hazirlik && hasRole(FIRMA)) {
    return children;
  }

  if (
    (durumId == YerbisConstants.ProjeDurumKodlari.Basvuru ||
      durumId == YerbisConstants.ProjeDurumKodlari.OnEtut ||
      durumId == YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari) &&
    hasRoles([IL_SUBE_MUDURU, SUBE_MUDURU])
  ) {
    return children;
  }

  return null;
}

function AraziBuroGoster({ children }) {
  const { getAraziBuroKontrol } = useProjeDetay();
  const inputDisable = getAraziBuroKontrol(true);

  if (inputDisable) {
    return null;
  }
  return children;
}

Can.propTypes = {
  perform: PropTypes.arrayOf(PropTypes.number).isRequired,
  notPerform: PropTypes.arrayOf(PropTypes.number),
  children: PropTypes.node.isRequired,
};

RolCalismaYetki.propTypes = {
  calismaTurId: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

HaritalarCalismasiIseGosterme.propTypes = {
  calismaTurId: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

TypeCan.propTypes = {
  types: PropTypes.arrayOf(PropTypes.number).isRequired,
  children: PropTypes.node.isRequired,
};

AraziBuroGoster.propTypes = {
  children: PropTypes.node.isRequired,
};

ProjeAlaniGuncelleButonuGoster.propTypes = {
  children: PropTypes.node.isRequired,
};

ProjePaftalariniYenidenOlusturButonuGoster.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Can;
export {
  TypeCan,
  RolCalismaYetki,
  HaritalarCalismasiIseGosterme,
  AraziBuroGoster,
  ProjeAlaniGuncelleButonuGoster,
  ProjePaftalariniYenidenOlusturButonuGoster,
};
